module.exports = __webpack_public_path__ + "static/finovate-spring-2016-ede66bd214017f677a8fa68a73ddcf82.png";